import { collection, DocumentSnapshot } from 'firebase/firestore';
import { collection as fsCollection } from 'rxfire/firestore';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IMetricMap, IUser } from '../types';
import { authenticatedUserProvider } from './userProvider';

export const rxMapOfMetricMaps = new BehaviorSubject<{
  [id: string]: IMetricMap;
}>({});

/**
 * @description A map of metric maps (2 Dimensional Mapping)
 */
authenticatedUserProvider()
  .pipe(
    switchMap((user: IUser): Observable<{ [id: string]: IMetricMap }> => {
      if (!user) return EMPTY;
      return fsCollection(collection(user.services.firestore, 'metrics')).pipe(
        map(
          (
            docs: DocumentSnapshot[]
          ): Array<{
            data: IMetricMap;
            id: string;
          }> => {
            return docs.map(
              (
                doc: DocumentSnapshot
              ): {
                data: IMetricMap;
                id: string;
              } => {
                const metricMap: IMetricMap = doc.data();
                return { data: metricMap, id: doc.id };
              }
            );
          }
        ),
        map(
          (
            MapArray: Array<{ data: IMetricMap; id: string }>
          ): {
            [id: string]: IMetricMap;
          } => {
            return MapArray.reduce(
              (
                acc: { [id: string]: IMetricMap },
                metricMap: { data: IMetricMap; id: string }
              ): { [id: string]: IMetricMap } => {
                acc[metricMap.id] = metricMap.data;
                return acc;
              },
              {}
            );
          }
        )
      );
    })
  )
  .subscribe(rxMapOfMetricMaps);
